import { ApiBusinessError } from '@/shared/api/result';
import { t } from '@/shared/i18n/messages';
import { normalizeMxRegisterPhone } from '@/features/auth/oro-mx-auth-phone';

export const LOGIN_NAME_MIN = 3;
export const LOGIN_NAME_MAX = 64;
export const LOGIN_PASSWORD_MIN = 6;
export const LOGIN_PASSWORD_MAX = 16;
export const REAL_NAME_MIN = 2;
export const REAL_NAME_MAX = 96;
const LOGIN_NAME_PATTERN = /^[a-zA-Z0-9_@.\-]{3,64}$/;

export function isGuestLoginName(loginName: string | null | undefined) {
  return !!loginName?.toLowerCase().startsWith('guest_');
}

export function toMxPhoneInput(phone: string | null | undefined) {
  return phone ? normalizeMxRegisterPhone(phone) : '';
}

export function isLoginAccountName(value: string) {
  return LOGIN_NAME_PATTERN.test(value.trim().toLowerCase());
}

export function isProfilePassword(value: string) {
  const length = value.trim().length;
  return length >= LOGIN_PASSWORD_MIN && length <= LOGIN_PASSWORD_MAX;
}

export function isAdultBirthday(value: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return false;
  }
  const birth = new Date(`${value}T00:00:00`);
  if (Number.isNaN(birth.getTime())) {
    return false;
  }
  const limit = new Date();
  limit.setHours(0, 0, 0, 0);
  limit.setFullYear(limit.getFullYear() - 18);
  return birth <= limit;
}

export function isRealNameLength(value: string) {
  const length = value.trim().length;
  return length >= REAL_NAME_MIN && length <= REAL_NAME_MAX;
}

/** 留空表示不改展示名；有内容时必须落在服务端 2–96。 */
export function resolveProfileDisplayName(input: {
  loginName: string;
  realName: string;
  storedDisplayName?: string | null;
}) {
  const typed = input.realName.trim();
  if (typed) return typed;
  const stored = input.storedDisplayName?.trim();
  if (stored) return stored;
  return input.loginName;
}

export function validateProfileEdit(input: {
  canEditLoginName: boolean;
  loginChanged: boolean;
  loginName: string;
  password: string;
  realName: string;
}): string {
  if (input.canEditLoginName && input.loginChanged) {
    if (!isLoginAccountName(input.loginName)) {
      return t('oro.edit.errAccount');
    }
    if (!isProfilePassword(input.password)) {
      return t('oro.edit.errPassword');
    }
  }
  if (input.realName.trim() && !isRealNameLength(input.realName)) {
    return t('oro.edit.errRealName');
  }
  return '';
}

export function profileEditErrorMessage(error: unknown) {
  if (error instanceof ApiBusinessError) {
    if (error.code === 'PLAYER_LOGIN_NAME_TAKEN') {
      return t('oro.edit.errTaken');
    }
    if (error.code === 'PLAYER_PHONE_TAKEN') {
      return t('oro.edit.errPhoneTaken');
    }
    if (error.code === 'PLAYER_EMAIL_TAKEN') {
      return t('oro.edit.errEmailTaken');
    }
    if (error.code === 'VALIDATION_INVALID') {
      return t('profile.errSave');
    }
    return t('profile.errSave');
  }
  return t('profile.errNetwork');
}
